import { IconChevronLeft } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import classNames from 'classnames';

export interface INSBreadcrumbBackLinkProps {
    message?: string;
    callback: () => void;
    containerClassName?: string;
    containerStyle?: any;
    icon?: any;
    isSmall?: boolean;
}

const NSBreadcrumbBackLink = ({
    message, callback, containerClassName, containerStyle, icon, isSmall = true,
}: INSBreadcrumbBackLinkProps) => (
    <div className={containerClassName} style={containerStyle}>
        <span className={classNames(['cursor--pointer text-primary', { small: !!isSmall }])} onClick={callback} role="presentation">
            <NSIcon icon={icon || IconChevronLeft} className="pr-1" />
            {message || 'back'}
        </span>
    </div>
);

export default NSBreadcrumbBackLink;
